import FormUtils from "../../../../utils/classUtils/FormUtils";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import AffiliateBranchesFormPresenter from "./AffiliateBranchesFormPresenter";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import CustomFormFactory from "../../../../components/CustomFormFactory/CustomFormFactory";
import withRouter from "../../../../utils/withRouter";

class AffiliateBranchesFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new AffiliateBranchesFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase()
    );
  }

  getCollectionName() {
    return "branches";
  }

  onSubmitForm(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      write: [user.id, "role:admin", "*"],
    };
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());
    const { object } = this.state;

    return (
      <PageContainer title="Affiliate Branches">
        <form onSubmit={this.onSubmitForm.bind(this)}>
          <CustomFormFactory
            schema={this.transformFieldsToSections({ fields, sections })}
            object={object}
            fieldsToExlude={this.fieldsToExclude}
            onChange={this.onChange.bind(this)}
            navigateBack={this.navigateBack.bind(this)}
          />
        </form>
      </PageContainer>
    );
  }
}

export default withRouter(AffiliateBranchesFormPage);
